export default __webpack_public_path__ + "static/media/ps2.9228098a.jpeg";